/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'archiveCustomerRunnerTicketHooksBySystemGameId',
    message: messages.SUCCESS_ARCHIVE_CUSTOMER_RUNNER_TICKET_HOOKS_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-hooks/:systemGameId/archive',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.ARCHIVE_CUSTOMER_RUNNER_TICKET_HOOK,
    requestSchema: requestSchemas.customerRunnerTicketHooks.archiveCustomerRunnerTicketHooksBySystemGameId,
  },
  {
    action: 'createCustomerRunnerTicketHookBySystemGameId',
    message: messages.SUCCESS_CREATE_CUSTOMER_RUNNER_TICKET_HOOK_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/customer/:customerId/runner-ticket-hook/:systemGameId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_CUSTOMER_RUNNER_TICKET_HOOK,
    requestSchema: requestSchemas.customerRunnerTicketHooks.createCustomerRunnerTicketHookBySystemGameId,
  },
  {
    action: 'copyCustomerRunnerTicketHooksBySystemGameId',
    message: messages.SUCCESS_COPY_CUSTOMER_RUNNER_TICKET_HOOKS_BY_SYSTEM_GAME_ID,
    method: 'POST',
    path: '/customer/:customerId/runner-ticket-hooks/:systemGameId/copy',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.COPY_CUSTOMER_RUNNER_TICKET_HOOK,
    requestSchema: requestSchemas.customerRunnerTicketHooks.copyCustomerRunnerTicketHooksBySystemGameId,
  },
  {
    action: 'deleteCustomerRunnerTicketHooksBySystemGameId',
    message: messages.SUCCESS_DELETE_CUSTOMER_RUNNER_TICKET_HOOKS_BY_SYSTEM_GAME_ID,
    method: 'DELETE',
    path: '/customer/:customerId/runner-ticket-hooks/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_RUNNER_TICKET_HOOK,
    requestSchema: requestSchemas.customerRunnerTicketHooks.deleteCustomerRunnerTicketHooksBySystemGameId,
  },
  {
    action: 'getCustomerRunnerTicketHooksBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_RUNNER_TICKET_HOOKS_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/runner-ticket-hooks/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_RUNNER_TICKET_HOOK,
    requestSchema: requestSchemas.customerRunnerTicketHooks.getCustomerRunnerTicketHooksBySystemGameId,
    scopes: [
      scopes.CUSTOMER_RUNNER_TICKET_HOOKS_ARCHIVED_BY_SYSTEM_GAME_ID,
      scopes.CUSTOMER_RUNNER_TICKET_HOOKS_INPUT_BY_SYSTEM_GAME_ID,
      scopes.DEFAULT,
    ],
  },
  {
    action: 'unarchiveCustomerRunnerTicketHooksBySystemGameId',
    message: messages.SUCCESS_UNARCHIVE_CUSTOMER_RUNNER_TICKET_HOOKS_BY_SYSTEM_GAME_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-hooks/:systemGameId/unarchive',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.UNARCHIVE_CUSTOMER_RUNNER_TICKET_HOOK,
    requestSchema: requestSchemas.customerRunnerTicketHooks.unarchiveCustomerRunnerTicketHooksBySystemGameId,
  },
  {
    action: 'updateCustomerRunnerTicketHookById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_TICKET_HOOK_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-ticket-hook/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_TICKET_HOOK,
    requestSchema: requestSchemas.customerRunnerTicketHooks.updateCustomerRunnerTicketHookById,
  },
];
